/*
 * @Author: your name
 * @Date: 2021-06-22 19:05:22
 * @LastEditTime: 2021-06-22 19:27:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/config/env.js
 */
// 配置编译环境和线上环境之间的切换

let url = ''
const iconfontVersion = ['567566_pwc3oottzol', '1066523_6bvkeuqao36']
const iconfontUrl = '//at.alicdn.com/t/font_$key.css'
const codeUrl = `${url}/code`
const { env } = process || { env: {} }
if (env.NODE_ENV === 'development') {
  url = '' // 开发环境地址
} else if (env.NODE_ENV === 'production') {
  url = '' // 生产环境地址
} else if (env.NODE_ENV === 'test') {
  url = '' // 测试环境地址
}
const baseUrl = url
export {
  baseUrl,
  iconfontUrl,
  iconfontVersion,
  codeUrl,
  env,
}
